<a *ngIf="showContactShortcut" pTooltip="Nous contacter" id="contact-us" tooltipPosition="left" style="cursor: pointer" class="layout-config-button" (click)="goNousContacter()">
    <i class="pi pi-phone"></i>
</a>
